import { render } from "./SignUp.vue?vue&type=template&id=3c95e5a0&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=3c95e5a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c95e5a0"

export default script